import { configureStore } from "@reduxjs/toolkit";
import { sidebarReducerInner } from "./sidebarSlice/Reducer";
import { tockenReducerInner } from "./AccessTocken/tocken";
import { loginReducerInner } from "./Login/loginReducer";
import { CompanyReducerInner } from "./Company/Reducer";

const store = configureStore({
  reducer: {
    // Login page and layout reducers
    sidebar: sidebarReducerInner.reducer,
    AccessTocken: tockenReducerInner.reducer,
    Login: loginReducerInner.reducer,

    // Normal page reducers
    company: CompanyReducerInner.reducer,
  },
});

//Login and layout reducers
export const loginReducer = loginReducerInner.actions;
export const AccessTockenReducer = tockenReducerInner.actions;
export const sidebarReducer = sidebarReducerInner.actions;

// Normal page reducers
export const CompanyReducer = CompanyReducerInner.actions;

export default store;
